// extracted by mini-css-extract-plugin
module.exports = {"main":"StartPage_main__xxy9M","title":"StartPage_title__1tKrV"};